import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { AuthService } from 'src/common/services/auth/auth.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { StatService } from 'src/services/stat/stat.service';

@Component({
  selector: 'app-graph-card',
  templateUrl: './graph-card.component.html',
  styleUrls: ['./graph-card.component.scss']
})
export class GraphCardComponent implements OnInit {

  public GLOBAL = new GlobalConstants();

  showLegend: boolean = false;
  showLabels: boolean = false;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';


  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Year';
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Leads';
  animations: boolean = true;

  stats: StatService;
  year: number = new Date().getFullYear();


  public customColors: any[] = [
    { name: 'Cold', value: '#B1E9E1' }, // Red
    { name: 'Warm', value: '#FF8C00' }, // Green
    { name: 'Hot', value: '#FF4500' }, // Blue
    { name: 'VEFA', value: '#4CAF50' }, // Blue
    // Add more mappings as needed
  ];
  constructor(
    protected afs: AngularFirestore,
    protected setting: SettingService,
    public auth: AuthService,
  ) {
    this.stats = new StatService(afs, setting, auth);


  }

  ngOnInit(): void {
    this.stats.initList("sales", this.auth.profile.values.agency, this.auth.uid, this.year, null, null, null, false);
  }

}

